<template>
  <component :is="unitData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="unitData === undefined">
      <h4 class="alert-heading">獲取商品單位時出錯</h4>
      <div class="alert-body">
        找不到相關商品單位記錄。請查看
        <b-link class="alert-link" :to="{ name: 'units-list' }">
          商品單位列表
        </b-link>
      </div>
    </b-alert>
    <unit-edit-tab-information
      v-if="unitData"
      :unit-data="unitData"
      class="p-sm-2"
      @refetch-data="refetchData"
    />
      <!-- :product-unit-status-options="productUnitStatusOptions" -->

  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import unitStoreModule from "../unitStoreModule";
import unitEditTabInformation from "./unitEditTabInformation.vue";

export default {
  components: {
    unitEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const unitData = ref({ id: 0 });
    const unit = {
      id: 0,
      is_active : 1
    };

    const unit_APP_STORE_MODULE_NAME = "unit";

    if (!store.hasModule(unit_APP_STORE_MODULE_NAME))
      store.registerModule(unit_APP_STORE_MODULE_NAME, unitStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(unit_APP_STORE_MODULE_NAME))
        store.unregisterModule(unit_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "product-unit-create") {
        unitData.value = unit;
      } else {
        
        store
          .dispatch("unit/fetchProductUnit", { id: router.currentRoute.params.id })
          .then((response) => {
            unitData.value = response.data.product_unit;
            console.log(unitData.value)
          })
          .catch((error) => {
            console.log("error when fetching unit", error);
            if (error.response.status === 404) {
              unitData.value = undefined;
            }
          });
      }
    };
    // const productUnitStatusOptions = ref([]);

    // const refetchOption = () => {
    //   store
    //     .dispatch("app/fetchOptionList", {
    //       product_units: true,
    //     })
    //     .then((response) => {
    //       productUnitStatusOptions.value = response.data.product_unit;
    //     });
    // };

    onMounted(() => {
      refetchData();
      // refetchOption();
    });

    return {
      // productUnitStatusOptions,
      unitData,
      refetchData,
      // refetchOption,
    };
  },
};
</script>
